import React, { useState } from "react";
import { connect } from "react-redux";
import { defaultAction } from "@actions/defaultAction";

import {
  SET_CATEGORY,
  CHANGE_BUY_SEARCH_TEXT,
  SHOW_ALL_MERCHANTS
} from "@constants/actionTypes";
import Category from "./Category";
import { ClearedStyleRouterLink } from "@modules/Components";
import styled from "@emotion/styled";
import { useLocation } from "react-router-dom";

const MobileMainContainer = styled.div`
  display: grid;
  flex-direction: row;
  grid-template-columns: 60px 1fr;
  align-items: baseline;
  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

const Link = styled(ClearedStyleRouterLink)`
  font-weight: 500;
  color: #1f2021;
`;

const InnerSpan = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #777984;
  @media (max-width: 500px) {
    display: none;
  }
`;

const CategoryContainerWrapper = styled.div`
  position: absolute;
  z-index: 100;
  background-color: rgba(31, 32, 33, 0.9);
  top: 0;
  right: 0;
  width: 100%;
  bottom: 0;
`;

const CategoryContainer = styled.div`
  font-weight: 500;
  line-height: 2.36;
  color: #777984;
  width: 375px;
  margin: 0 auto;
  background: white;
  border-radius: 5px;
  box-shadow: 0 5px 20px 0 rgba(38, 38, 38, 0.05);
  padding-left: 25px;
  padding-bottom: 16px;
  margin-top: 40px;
  position: relative;
  border-radius: 30px;
  @media (max-height: 829px) {
    margin-top: 20px;
  }
  @media (max-height: 800px) {
    margin-top: 10px;
  }
  @media (max-height: 790px) {
    margin-top: 30px;
    height: 80vh;
  }
  @media (max-height: 750px) {
    margin-top: 10px;
  }
  @media (max-height: 725px) {
    overflow-y: scroll;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      width: 0px;
    }
  }
  @media (max-height: 660px) {
    height: 81vh;
  }
  @media (max-height: 600px) {
    height: 79vh;
  }
  @media (max-height: 535px) {
    height: 78vh;
  }

  @media (max-width: 400px) {
    width: 300px;
  }
`;

const CloseImageDiv = styled.div`
  position: absolute;
  width: 100%;
`;

const InnerDiv = styled.div`
  color: ${props => props.color};
  &:hover {
    color: ${props => props.hoverColor};
  }
  font-size: 13px;
`;

const CategoryHeader = styled.div`
  font-weight: 500;
  line-height: normal;
  color: #1f2021;
  font-size: 14px;
  cursor: pointer;
  @media (max-width: 430px) {
    font-size: 13px;
  }
  @media (max-width: 400px) {
    font-size: 12px;
  }
`;

const DealsContainer = styled.div`
  margin-bottom: 15px;
  @media (max-height: 790px) {
    margin-bottom: 8px;
  }
  @media (max-width: 767px) {
    display: grid;
  }
`;

const BottomCategoryHeader = styled(CategoryHeader)`
  margin-top: 15px;
`;

const FilteredCategoryContainer = styled.div`
  @media (max-width: 767px) {
    display: grid;
  }
`;

const IconSpan = styled.span`
  margin-left: 10px;
`;

const CloseImage = styled.img`
  position: absolute;
  top: 25px;
  right: 49px;
  cursor: pointer;
`;

const ModuleHeader = styled.div`
  font-size: 24px;
  text-align: center;
  color: #1f2021;
  padding-top: 23px;
  @media (max-height: 790px) {
    line-height: 1.5;
  }
`;

const MobileCategories = ({
  categories,
  userActions,
  showAllMerchants,
  filterCategory,
  categoryName,
  changeSearchText,
  newGifting
}) => {
  const [hideModule, changeHideModule] = useState("none");
  const [dropdownName, changeDropdownName] = useState(
    categoryName ? categoryName : "Show all cards"
  );

  const pathname = useLocation().pathname;

  const moveToCategory = (url, name = "Show all cards") => {
    changeDropdownName(name);
    filterCategory(url);
    hide();
  };

  const renderCategory = (categories, newUrl) =>
    categories.map(topic => (
      <Category
        key={topic.categoryId}
        url={newUrl ? `new/${topic.url}` : topic.url}
        categoryId={topic.categoryId}
        categoryName={topic.categoryName}
        moveToCategory={moveToCategory}
        categoryUrl={topic.url}
        userActions={userActions}
        currentSelectedCategoryName={categoryName}
      />
    ));

  let filteredCategories = [];
  let dealsCategories = [];
  let allRecipients = [];
  let allOccasions = [];

  if (categories.length) {
    filteredCategories = categories.filter(category => category.listId === 1)[0]
      .categories;

    dealsCategories = categories.filter(category => category.listId === 2)[0]
      .categories;

    allRecipients = categories.filter(category => category.listId === 3)[0]
      .categories;

    allOccasions = categories.filter(category => category.listId === 4)[0]
      .categories;
  }

  const hide = () => {
    document.body.style.overflow = "initial";
    changeHideModule("none");
  };

  const show = () => {
    if (hideModule === "none") {
      changeHideModule("inherit");
      document.body.style.overflow = "hidden";
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const windowObj = typeof window !== "undefined" ? window : global;
  let displayName;

  if (windowObj.innerWidth > 375) {
    displayName = dropdownName;
  } else if (windowObj.innerWidth > 340) {
    if (dropdownName.length < 25) {
      displayName = dropdownName;
    } else {
      displayName = `${dropdownName.slice(0, 23)}...`;
    }
  } else {
    if (dropdownName.length < 18) {
      displayName = dropdownName;
    } else {
      displayName = `${dropdownName.slice(0, 16)}...`;
    }
  }

  return (
    <MobileMainContainer>
      <InnerSpan>Display</InnerSpan>
      <div>
        <CategoryHeader onClick={show}>
          {displayName}
          <IconSpan>
            <i className="fa fa-angle-down" />
          </IconSpan>
        </CategoryHeader>

        <CategoryContainerWrapper style={{ display: hideModule }}>
          <CategoryContainer className="mobile-category-container">
            <CloseImageDiv>
              <CloseImage
                src="https://cdn.cardcash.com/website/ui/elements/close.svg"
                onClick={hide}
                alt="close button"
              />
            </CloseImageDiv>
            <ModuleHeader>Display:</ModuleHeader>
            <Link to={`/buy-gift-cards/${newGifting ? "new/" : ""}`}>
              <InnerDiv
                onClick={() => {
                  showAllMerchants();
                  moveToCategory("");
                  changeSearchText("");
                }}
                color={pathname === "/buy-gift-cards/" ? "#ff9c1b" : "#777984"}
                hoverColor={
                  pathname === "/buy-gift-cards/" ? "#ff9c1b" : "#1f2021"
                }
              >
                Show All Cards
              </InnerDiv>
            </Link>
            <Link to={`/buy-gift-cards/epic-discounts/`}>
              <InnerDiv
                onClick={() => {
                  showAllMerchants();
                  moveToCategory("");
                  changeSearchText("");
                }}
                color={
                  pathname === "/buy-gift-cards/epic-discounts/"
                    ? "#ff9c1b"
                    : "#777984"
                }
                hoverColor={
                  pathname === "/buy-gift-cards/epic-discounts/"
                    ? "#ff9c1b"
                    : "#1f2021"
                }
              >
                Epic 20%+ discounts
              </InnerDiv>
            </Link>
            {!newGifting && (
              <DealsContainer>{renderCategory(dealsCategories)}</DealsContainer>
            )}

            <FilteredCategoryContainer>
              {newGifting ? (
                <>
                  <CategoryHeader>By Recipient</CategoryHeader>
                  {renderCategory(allRecipients, true)}
                  <BottomCategoryHeader>By Occasion</BottomCategoryHeader>
                  {renderCategory(allOccasions, true)}
                </>
              ) : (
                renderCategory(filteredCategories)
              )}
            </FilteredCategoryContainer>
          </CategoryContainer>
        </CategoryContainerWrapper>
      </div>
    </MobileMainContainer>
  );
};

export default connect(
  state => ({
    categories: state.categories.allCategories,
    userActions: state.userActions
  }),
  dispatch => ({
    filterCategory: category => dispatch(defaultAction(SET_CATEGORY, category)),
    changeSearchText: e => {
      dispatch(defaultAction(CHANGE_BUY_SEARCH_TEXT, e));
    },
    showAllMerchants: () => dispatch(defaultAction(SHOW_ALL_MERCHANTS))
  })
)(MobileCategories);
